"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapNovasolFeaturesToAggregationFeatures = exports.mapNovasolIncludedExtras = exports.splitObjectByKeys = void 0;
const da_json_1 = __importDefault(require("@awaze/mfe-common.contexts.intl/localization/translation-files/mfe-common/da.json"));
const de_json_1 = __importDefault(require("@awaze/mfe-common.contexts.intl/localization/translation-files/mfe-common/de.json"));
const en_json_1 = __importDefault(require("@awaze/mfe-common.contexts.intl/localization/translation-files/mfe-common/en.json"));
const es_json_1 = __importDefault(require("@awaze/mfe-common.contexts.intl/localization/translation-files/mfe-common/es.json"));
const fr_json_1 = __importDefault(require("@awaze/mfe-common.contexts.intl/localization/translation-files/mfe-common/fr.json"));
const hr_json_1 = __importDefault(require("@awaze/mfe-common.contexts.intl/localization/translation-files/mfe-common/hr.json"));
const it_json_1 = __importDefault(require("@awaze/mfe-common.contexts.intl/localization/translation-files/mfe-common/it.json"));
const pl_json_1 = __importDefault(require("@awaze/mfe-common.contexts.intl/localization/translation-files/mfe-common/pl.json"));
const nl_json_1 = __importDefault(require("@awaze/mfe-common.contexts.intl/localization/translation-files/mfe-common/nl.json"));
const nb_json_1 = __importDefault(require("@awaze/mfe-common.contexts.intl/localization/translation-files/mfe-common/nb.json"));
const sv_json_1 = __importDefault(require("@awaze/mfe-common.contexts.intl/localization/translation-files/mfe-common/sv.json"));
const splitObjectByKeys = (obj, keys) => Object.entries(obj).reduce((acc, [key, value]) => {
    if (keys.includes(key)) {
        acc[0][key] = value;
    }
    else {
        acc[1][key] = value;
    }
    return acc;
}, [{}, {}]);
exports.splitObjectByKeys = splitObjectByKeys;
const [includedExtrasDa, featureMappingsDa] = (0, exports.splitObjectByKeys)(da_json_1.default, ['201', '202']);
const [includedExtrasDe, featureMappingsDe] = (0, exports.splitObjectByKeys)(de_json_1.default, ['201', '202']);
const [includedExtrasEn, featureMappingsEn] = (0, exports.splitObjectByKeys)(en_json_1.default, ['201', '202']);
const [includedExtrasEs, featureMappingsEs] = (0, exports.splitObjectByKeys)(es_json_1.default, ['201', '202']);
const [includedExtrasFr, featureMappingsFr] = (0, exports.splitObjectByKeys)(fr_json_1.default, ['201', '202']);
const [includedExtrasHr, featureMappingsHr] = (0, exports.splitObjectByKeys)(hr_json_1.default, ['201', '202']);
const [includedExtrasIt, featureMappingsIt] = (0, exports.splitObjectByKeys)(it_json_1.default, ['201', '202']);
const [includedExtrasPl, featureMappingsPl] = (0, exports.splitObjectByKeys)(pl_json_1.default, ['201', '202']);
const [includedExtrasNl, featureMappingsNl] = (0, exports.splitObjectByKeys)(nl_json_1.default, ['201', '202']);
const [includedExtrasNb, featureMappingsNb] = (0, exports.splitObjectByKeys)(nb_json_1.default, ['201', '202']);
const [includedExtrasSv, featureMappingsSv] = (0, exports.splitObjectByKeys)(sv_json_1.default, ['201', '202']);
const getMappedExtras = (language) => {
    switch (language || '') {
        case 'da':
            return includedExtrasDa;
        case 'de':
            return includedExtrasDe;
        case 'en':
            return includedExtrasEn;
        case 'es':
            return includedExtrasEs;
        case 'fr':
            return includedExtrasFr;
        case 'hr':
            return includedExtrasHr;
        case 'it':
            return includedExtrasIt;
        case 'nl':
            return includedExtrasNl;
        case 'nb':
            return includedExtrasNb;
        case 'sv':
            return includedExtrasSv;
        case 'pl':
            return includedExtrasPl;
        default:
            return includedExtrasEn;
    }
};
const mapNovasolIncludedExtras = (includedExtras, language) => {
    const extrasTranslations = getMappedExtras(language);
    const extrasWithTranslations = includedExtras.filter((extraId) => extrasTranslations[extraId]);
    return extrasWithTranslations.map((extraId) => ({
        includedExtraId: extraId,
        includedExtraName: extrasTranslations[extraId],
    }));
};
exports.mapNovasolIncludedExtras = mapNovasolIncludedExtras;
const getMappedFeatures = (language) => {
    switch (language || '') {
        case 'da':
            return featureMappingsDa;
        case 'de':
            return featureMappingsDe;
        case 'en':
            return featureMappingsEn;
        case 'es':
            return featureMappingsEs;
        case 'fr':
            return featureMappingsFr;
        case 'hr':
            return featureMappingsHr;
        case 'it':
            return featureMappingsIt;
        case 'nl':
            return featureMappingsNl;
        case 'nb':
            return featureMappingsNb;
        case 'sv':
            return featureMappingsSv;
        case 'pl':
            return featureMappingsPl;
        default:
            return featureMappingsEn;
    }
};
const mapNovasolFeaturesToAggregationFeatures = (features, language) => {
    const featureMappings = getMappedFeatures(language);
    return features.map((feature) => ({
        ...feature,
        featureCode: null,
        featureName: featureMappings[feature.featureId]
            ? featureMappings[feature.featureId]
            : feature.featureId,
    }));
};
exports.mapNovasolFeaturesToAggregationFeatures = mapNovasolFeaturesToAggregationFeatures;
//# sourceMappingURL=novasol.js.map